import React from 'react';
import AddOnQuantityInput from '../add-on/AddOnQuantityInput';
import './EventAddOnInputs.css';

/**
 * Sign-up add-ons of an event as quantity inputs (add form, participant edit popup) — one AddOnQuantityInput per
 * add-on in process order.
 * addOns: EventAddOnInfo[] with bookableOnSignup; values: { [addOnId]: quantity }; onChange(addOnId, quantity).
 * hintFor(addOn, quantity) → second line (price, "noch 2 frei", …); disabledFor(addOn, quantity) → lock one row;
 * maxFor(addOn) → optional upper bound of one row below maxPerPerson (null = none, e.g. the remaining stock).
 * disabled: locks every row (e.g. "Spieltagleitung" on) — `note` explains why. label: small section label (add form;
 * popups have their own heading). children: extra rows below (e.g. read-only orphan lines).
 */
function EventAddOnInputs({ addOns, values, onChange, hintFor, disabledFor, maxFor, disabled = false, note = null, label = null, children }) {
  const list = Array.isArray(addOns) ? addOns : [];
  return (
    <div className="eventAddOnInputs" role="group" aria-label={label ?? 'Zusätze'}>
      {label && <span className="eventAddOnInputsLabel">{label}</span>}
      {list.map(a => {
        const quantity = Number(values?.[a.addOnId] ?? 0);
        return (
          <AddOnQuantityInput
            key={a.addOnId}
            addOn={{ addOnId: a.addOnId, name: a.name, maxPerPerson: a.maxPerPerson }}
            value={quantity}
            onChange={q => onChange?.(a.addOnId, q)}
            disabled={disabled || !!disabledFor?.(a, quantity)}
            hint={hintFor?.(a, quantity) ?? undefined}
            max={maxFor?.(a) ?? null}
          />
        );
      })}
      {children}
      {note && <p className="formFieldHint eventAddOnInputsNote">{note}</p>}
    </div>
  );
}

export default EventAddOnInputs;
